<div class="flex flex-col h-full">
  <app-nav></app-nav>
  <app-search-results [initialTab]="initialTab" [initialSearchText]="initialSearchText" [initialState]="initialState" [initialLga]="initialLga"></app-search-results>
</div>
